import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
// import ScrollToTop from "react-scroll-to-top";
// import { Link } from "react-router-dom";
import ContentLoader from "react-content-loader";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import serverPath from ".././serverpath.js";
import { makeActive } from "../dataStore/slice/ActiveSlice";

import listjson from "../helplist/listData.json";
import TechErrorPage from "../MiscCompo/TechErrorPage.jsx";

const Transit = (props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const topdiv = useRef();

	// const hrefval = window.location.href;
	// console.log(hrefval);

	const location = useLocation();
	// const q = new URLSearchParams(location.search);
	// const file = q.get("noderoot");
	const urlhash = location.hash.substring(1);
	// console.log(urlhash);

	const qparams = useSearchParams();
	const strQparams = qparams[0].toString();
	// console.log(strQparams);

	const { iid } = useParams();
	// const { id } = useParams();
	// console.log("iid -> ",iid);
	// console.log("id -> ", id);

	const [stepData, setStepData] = useState(null);
	// const [imgUrl, setImageUrl] = useState(null);
	const [contentloader, setloader] = useState(true);
	const [isTechError, setIsTechError] = useState(false);

	useEffect(() => {
		// console.log("useEffect start");
		setloader(true);

		const getacc = listjson.find((accordion) => {
			// console.log(accordion);
			let childpath =
				accordion.child &&
				accordion?.child.find((childd) => {
					// console.log(child);
					if (childd.id === iid) {
						return childd;
					}
					return null;
				});
			// console.log(childpath);
			if (childpath) {
				return childpath;
			}
		});
		if (!getacc) {
			const boxerr = { msg: "Err 404 Page not found / Invalid URL" };
			// props.deployNotifier(boxerr);
			// navigate("/");
			navprocess(boxerr);
		}
		// console.log(getacc);
		if (getacc) {
			const getchildpath = getacc?.child.find((child) => {
				return child.id === iid;
			});
			// console.log(getchildpath.nodepath);

			fetch(serverPath.dypath ? `${serverPath.dypath}transit` : "/transit", {
				// Adding method type
				method: "POST",
				// Adding body or contents to send
				body: JSON.stringify({
					path: getchildpath.nodepath,
				}),
				// Adding headers to the request
				headers: {
					"Content-type": "application/json; charset=UTF-8",
				},
			})
				.then((response) => {
					// console.log("resp", response);
					return response.json();
				})
				// .then((jsonData) => console.log("-----------", jsonData))
				.then((jsonData) => {
					// console.log("data", jsonData[0].head);
					setStepData(jsonData);
					setloader(false);
				})
				.catch((error) => {
					const boxerr = { msg: "Technical Error - fail to fetch data" };
					console.error(error, "jckCatch");
					// navigate(-1);
					navprocess(boxerr);
				});
		}
	}, [iid, navigate]);
	// console.log("---------stepData : ", stepData);

	/* const checkele = () => {
		if (urlhash) {
			console.log("if urlhash", urlhash);
			const element = document.getElementById(`${urlhash}`);
			console.log(element);
			element.scrollIntoView({ behavior: "smooth" });
		}
	}; */

	// const hashdiv = useRef();
	// console.log(hashdiv);
	// const topdiv1 = document.getElementsByClassName(".content-compo");
	// console.log(topdiv1);
	const scrolleffect = () => {
		// console.log("scroll use effect");
		// console.log(urlhash);
		const element = document.getElementById(`${urlhash}`);
		// const topid = document.getElementById('topid');
		if (urlhash && stepData && element) {
			// console.log("scroll if");
			// console.log(urlhash, element);
			// console.log("if urlhash", urlhash);
			// const element = document.getElementById(`${urlhash}`);
			// console.log(element);
			// hashdiv.current.scrollIntoView({ behavior: "smooth", block: "start" });
			element.scrollIntoView({ block: "start", behavior: "smooth" });
		} else {
			if (topdiv.current) {
				// console.log("else if scroll");
				// console.log(topdiv);
				//
				topdiv.current.scrollIntoView({ block: "start" });
				// topid.scrollIntoView({ behavior: "smooth" });
				/* window.scrollTo({
					top: 0,
					left: 0,
					behavior: "smooth",
				}); */
			}
		}
	};
	const navprocess = (boxerr) => {
		// Set a timeout to hide the component after 5 seconds
		const timeoutId = setTimeout(() => {
			props.deployNotifier(boxerr);
			setTimeout(() => {
				// navigate(-1);
				setloader(false);
				setIsTechError(true);
			}, 4000);
		}, 2000);
		return () => clearTimeout(timeoutId);
	};

	/* useEffect(() => {
		scrolleffect();
	}, [urlhash]); */
	/* useEffect(() => {
		// Set a timeout to hide the component after 5 seconds
		const timeoutId = setTimeout(() => {
			setcallbox(false);
		}, 5000);

		// Clear the timeout if the component is unmounted before the timeout expires
		return () => {
			clearTimeout(timeoutId);
			navigate("/");
		};
	}, [callPopbox]); */
	useEffect(() => {
		setTimeout(() => scrolleffect(), 300);
		dispatch(makeActive(`${iid}`));
		// return () => clearTimeout(timeoutId);
	});

	return (
		<>
			{/* {imgUrl && imgUrl[0].imageSrc} */}
			{contentloader && (
				<div className="loader">
					<div className="load1">
						<ContentLoader viewBox="0 0 476 124">
							<rect x="48" y="8" width="88" height="6" rx="3" />
							<rect x="48" y="26" width="52" height="6" rx="3" />
							<rect x="0" y="56" width="410" height="6" rx="3" />
							<rect x="0" y="72" width="380" height="6" rx="3" />
							<rect x="0" y="88" width="178" height="6" rx="3" />
							<circle cx="20" cy="20" r="20" />
						</ContentLoader>
					</div>
					<div className="load2">
						<ContentLoader viewBox="0 0 400 31" height={31} width={400}>
							<rect height="5.5" rx="1" ry="1" width="340" x="31" y="5" />
							<rect height="5.5" rx="1" ry="1" width="340" x="31" y="15" />
							<circle cx="388" cy="12" r="12" />
							<rect height="24" rx="0" ry="0" width="24" x="0" y="0" />
						</ContentLoader>
					</div>
					<div className="load3">
						<ContentLoader viewBox="0 0 500 500" height={200} width={200} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
							<path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
							<ellipse cx="120" cy="140" rx="28" ry="28" />
						</ContentLoader>
						<ContentLoader viewBox="0 0 500 500" height={200} width={200} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
							<path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
							<ellipse cx="120" cy="140" rx="28" ry="28" />
						</ContentLoader>
					</div>
					<div className="load2">
						<ContentLoader viewBox="0 0 400 31" height={31} width={400}>
							<rect height="5.5" rx="1" ry="1" width="340" x="31" y="5" />
							<rect height="5.5" rx="1" ry="1" width="340" x="31" y="15" />
							<circle cx="388" cy="12" r="12" />
							<rect height="24" rx="0" ry="0" width="24" x="0" y="0" />
						</ContentLoader>
					</div>
					<div className="load3">
						<ContentLoader viewBox="0 0 500 500" height={200} width={200} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
							<path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
							<ellipse cx="120" cy="140" rx="28" ry="28" />
						</ContentLoader>
						<ContentLoader viewBox="0 0 500 500" height={200} width={200} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
							<path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
							<ellipse cx="120" cy="140" rx="28" ry="28" />
						</ContentLoader>
					</div>
				</div>
			)}
			{!contentloader && stepData && (
				<Helmet>
					<title>Plus Help - {stepData[0]["section-heading"]}</title>
				</Helmet>
			)}
			{!contentloader &&
				stepData &&
				(stepData ? (
					<div className="content-compo" ref={topdiv} id="topid">
						<div className="content-title">
							<h1>{stepData[0]["section-heading"]}</h1>
							<p className="content-desc">{stepData[0]["section-heading-desc"]}</p>
							<div className="myhr"></div>
							{stepData[0]["sub-section-link"] && (
								<div className="content-link">
									{/* <Link onClick={() => getele(createele)}> - How to create a new Item</Link>
						<Link onClick={() => getele(editele)}> - How to edit the saved Item</Link>
						<Link to="deleteel"> - How to Delete the Item</Link>
						<Link onClick={() => getele(advanceele)}> - Advance Item Management / Inventory Management</Link> */}
									{stepData[0]["sub-section-link"].map((hashlink, i) => {
										return (
											<div key={i}>
												{/* <Link to={`?${strQparams}#${hashlink["hash-link"]}`} scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}>
												{hashlink.name}
											</Link> */}
												<HashLink to={`?${strQparams}#${hashlink["hash-link"]}`} scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}>
													{`#${hashlink.name}`}
												</HashLink>
											</div>
										);
									})}
								</div>
							)}
						</div>

						{/* <div className="block-space"></div> */}

						{stepData[1]
							? stepData[1].map((subsec, i) => {
									if (subsec["sub-section-status"] === "deploy") {
										return (
											<div className="sub-content" id={subsec["hash-link-id"] ? subsec["hash-link-id"] : null} key={i}>
												<h2>{subsec["sub-section"]}</h2>
												{subsec["sub-section-desc"] &&
													subsec["sub-section-desc"]?.length > 0 &&
													subsec["sub-section-desc"].map((desc, i) => {
														return (
															<p className="subcontent-desc" key={i}>
																{desc}
															</p>
														);
													})}
												<div className="step">
													{subsec["sub-section-step"]
														? subsec["sub-section-step"].map((stepblock, i) => {
																if (stepblock["step-type"] === "step" && stepblock["image-scope"] === "v") {
																	return (
																		<div className={stepblock["image-scope"] === "v" ? "step-img-v" : "step-img-h"} key={i}>
																			<div>
																				<p>{stepblock["step-no"]}</p>
																				{stepblock?.["step-desc"] &&
																					stepblock["step-desc"].map((points, i) => {
																						return <p className="stepdesc" key={i}>{` -- ${points}`}</p>;
																					})}
																			</div>
																			<img src={`${serverPath.dypath}${stepData[0]["sec-img-path"]}${stepblock["step-image"]}`} alt={stepblock["step-image"]} />
																		</div>
																	);
																} else if (stepblock["step-type"] === "step" && stepblock["image-scope"] === "h") {
																	return (
																		<div className={stepblock["image-scope"] === "v" ? "step-img-v" : "step-img-h"} key={i}>
																			<p>{stepblock["step-no"]}</p>
																			{stepblock?.["step-desc"] &&
																				stepblock["step-desc"].map((points, i) => {
																					return <p className="stepdesc" key={i}>{` -- ${points}`}</p>;
																				})}
																			<div className="himgblock">
																				<img src={`${serverPath.dypath}${stepData[0]["sec-img-path"]}${stepblock["step-image"]}`} alt={stepblock["step-image"]} />
																			</div>
																		</div>
																	);
																} else if (stepblock["step-type"] === "note") {
																	return (
																		<div className="step-note" key={i}>
																			<p>
																				<b>Note : {stepblock?.["note-title"]}</b>
																			</p>
																			<p>{stepblock?.["note-desc"]}</p>
																			{stepblock?.["note-image"] && <img src={`${serverPath.dypath}${stepData[0]["sec-img-path"]}${stepblock["note-image"]}`} alt={stepblock["note-image"]} />}
																		</div>
																	);
																}
																return null;
														  })
														: null}
												</div>
											</div>
										);
									}
									return null;
							  })
							: null}
						<div className="block-space"></div>
						{/* <ScrollToTop smooth /> */}
					</div>
				) : (
					<h1>Sorry no data found</h1>
				))}
			{isTechError && !contentloader && <TechErrorPage />}
		</>
	);
};

export default Transit;
